import React, { useState } from "react";

const Tabs = ({ tabs, defaultTab, onTabChange, children, className = "" }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <div className={className}>
      <div className="flex gap-8 border-b border-[#E5E5E5]">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={`pb-4 w-full text-[16px] xl:text-[24px] font-[500] transition-colors text-black ${
              activeTab === tab.id
                ? " border-b-2 border-[#274DE0]"
                : ""
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="mt-6">
        {typeof children === "function" ? children(activeTab) : children}
      </div>
    </div>
  );
};

export default Tabs;

